import { atom } from "jotai";
import { RouterProvider, createHashRouter } from "react-router-dom";
import Root from "./routes/root";
import "./extensions/yup-extensions";
import TrafficInfo from "./routes/TrafficInfo";

const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        index: true,
        element: <TrafficInfo />,
      },
    ],
  },
]);

const pagePaths =
  router?.routes[0]?.children?.map((child) => child.path).filter(Boolean) || [];

export const pageCountAtom = atom({ pagePaths });

function App() {
  return <RouterProvider router={router} />;
}

export default App;
